import React, { CSSProperties, useEffect, useMemo, useState } from "react";

import { Checkbox, Dimmer, Divider, Loader } from "semantic-ui-react";

import CardEmployeeInfoHistoryUX from "./CardEmployeeInfoHistoryUX";

import {
  BTN_ACTS,
  MasterOptions,
  PickedState,
  RunSequence,
  State,
} from "./sequence/EmployeeHistory";

import { formatDatetime } from "react-lib/utils/dateUtils";

// Types
type CardEmployeeInfoHistoryProps = Pick<PickedState, "buttonLoadCheck"> & {
  runSequence: RunSequence;
  EmployeeHistorySequence: State["EmployeeHistorySequence"];
  masterOptions: MasterOptions;
};

type Styles = Record<"loader", CSSProperties>;

const styles: Styles = {
  loader: {
    alignItems: "flex-start",
    background: "transparent",
    marginLeft: "15px",
    padding: 0,
  },
};

const CardEmployeeInfoHistory = (props: CardEmployeeInfoHistoryProps) => {
  const [isShowAll, setIsShowAll] = useState<boolean>(false);

  useEffect(() => {
    props.runSequence({ sequence: "EmployeeHistory", restart: true });
  }, []);

  const filteredItems = useMemo(() => {
    const items = props.EmployeeHistorySequence?.items ?? [];

    return items.filter((item) =>
      isShowAll
        ? true
        : item.affiliate_changed ||
          item.position_changed ||
          item.amount_changed ||
          item.base_ot_changed
    );
  }, [isShowAll, props.EmployeeHistorySequence?.items]);

  const formattedItems = useMemo(
    () =>
      filteredItems.map((item) => {
        const division = props.masterOptions.division ?? [];
        const positionAll = props.masterOptions.positionAll ?? [];

        const foundAffiliate = division.find((option) => option.value === item.affiliate);
        const foundPosition = positionAll.find((option) => option.value === item.position);

        return {
          ...item,
          affiliateName: foundAffiliate?.text,
          amount: item.amount,
          base_ot: item.base_ot,
          created: formatDatetime(item.created, true),
          positionName: foundPosition?.text,
        };
      }),
    [filteredItems, props.masterOptions.division, props.masterOptions.positionAll]
  );

  console.log("CardEmployeeInfoHistory props:", props);

  return (
    <div
      style={{
        height: "calc(100vh - 6.5rem)",
        marginTop: "-1.5rem",
        overflowY: "auto",
        paddingTop: "1rem",
      }}
    >
      <div style={{ alignItems: "baseline", display: "flex" }}>
        <label
          style={{
            color: "rgba(26, 115, 232, 1)",
            fontSize: "0.95rem",
            fontWeight: "bold",
            paddingLeft: "10px",
          }}
        >
          Employee info history
        </label>

        <div style={{ position: "relative", width: "fit-content" }}>
          <Checkbox
            style={{ marginLeft: "1rem" }}
            checked={isShowAll}
            label="Show all history"
            onChange={(e, data) => {
              setIsShowAll(!!data.checked);
            }}
          />
          <Dimmer
            style={styles.loader}
            active={!!props.buttonLoadCheck?.[BTN_ACTS.SEARCH]}
            size="mini"
            inverted
          >
            <Loader size="mini" inline />
          </Dimmer>
        </div>
      </div>

      {formattedItems.map((item, index) => (
        <React.Fragment key={`card-history-${index}`}>
          {index > 0 && <Divider style={{ margin: "0 0.75rem" }} />}
          <CardEmployeeInfoHistoryUX data={item} />
        </React.Fragment>
      ))}
    </div>
  );
};

CardEmployeeInfoHistory.displayName = "CardEmployeeInfoHistory";

export default React.memo(CardEmployeeInfoHistory);
